import { EnvironmentProviders, Provider } from '@angular/core';

import { environment } from '@zeusm/environment';
import {
  SHELL_API as PERSONAL_SHELL_API,
  ShellApiMockService as PersonalShellApiMockService,
  ShellApiService as PersonalShellApiService,
  PersonalShellStore,
} from '@zeusm/personal/shell';
import { DICTIONARIES_API, DictionariesApiMockService, DictionariesApiService, DictionariesStore } from '@zeusm/personal/store';
import { provideApiService } from '@zeusm/shared/core/helpers';

import { CardsApiMockService } from './features/cards/api/cards-api.mock.service';
import { CardsApiService } from './features/cards/api/cards-api.service';
import { CARDS_API } from './features/cards/api/cards-api.token';
import { CardsStore } from './features/cards/cards.store';

const PERSONAL_STORES: (Provider | EnvironmentProviders)[] = [PersonalShellStore, DictionariesStore, CardsStore];
const PERSONAL_API_SERVICES: (Provider | EnvironmentProviders)[] = [
  {
    provide: PERSONAL_SHELL_API,
    useClass: provideApiService(environment.useMocks, PersonalShellApiMockService, PersonalShellApiService),
  },
  {
    provide: DICTIONARIES_API,
    useClass: provideApiService(environment.useMocks, DictionariesApiMockService, DictionariesApiService),
  },
  {
    provide: CARDS_API,
    useClass: provideApiService(environment.useMocks, CardsApiMockService, CardsApiService),
  },
];

export const PERSONAL_INFRASTRUCTURE_PROVIDERS: (Provider | EnvironmentProviders)[] = [...PERSONAL_STORES, ...PERSONAL_API_SERVICES];
